<template>
    <vx-card>
        <vs-row class="mb-4">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6" vs-sm="6" vs-xs="12">
            </vs-col>
            <vs-col class="mb-4" vs-type="grid" vs-justify="right" vs-align="right" vs-w="6" vs-sm="6" vs-xs="12">
                <span class="bg-fondo-1 p-4">
                    <div class="inline">
                        Asignatura: <h5 class="inline"> <b>{{ datos.libro }}</b> </h5>
                    </div>
                    <p>Docente: <b>{{ datos.docente }}</b> </p>
                    <p>Código: <b>{{ datos.codigo }}</b> </p>
                </span>
            </vs-col>
        </vs-row>
        <vs-tabs alignment="fixed">
            <vs-tab class="" label="Evaluaciones">
                <EvaluacionesEstudiantes />
            </vs-tab>
            <vs-tab class="" label="Tareas">
                <recursosEstudianteVue :codigoCurso="codigoCurso" class="mt-5"/>
            </vs-tab>
        </vs-tabs>
    </vx-card>
</template>
<script>
import EvaluacionesEstudiantes from "./evaluacionesEstudiantes.vue";
import recursosEstudianteVue from "./recursosEstudiante.vue";
export default {
    components: {
        EvaluacionesEstudiantes,
        recursosEstudianteVue
    },
    data() {
        return{
            datos : {
                'docente':'',
                'libro': '',
                'codigo':'',
            },
            codigoCurso:'',
        }
    },
    mounted(){
        let me = this
        me.datos = {
            'docente':  localStorage.getItem("docente"),
            'libro':    localStorage.getItem("nombreasignatura"),
            'codigo':   localStorage.getItem("codigo_curso"),
        };
        me.codigoCurso = me.datos.codigo;
        // console.log('aca elcodigo del curso',me.codigoCurso);
    }
}
</script>
<style lang="css" scoped>
.bg-fondo-1 {
    background-color: rgba(var(--vs-white1), 1) !important;
    border-radius: 10px;
}
</style>
